import { InputAdornment, ListSubheader } from "@mui/material";
import CoreTextField from "../form/TextField";
import SearchIcon from "../form/images/magnifying-glass.svg?react";
import i18nPackage from "../../i18n/i18n";

export type CoreSelectSearchProps = {
	placeholder?: string;
	value: string;
	onChange: (text: string) => void;
};

// Interface for the internal helper component
export type DropdownSearchHeaderProps = {
	searchProps: CoreSelectSearchProps;
};

export default function DropdownSearchHeader({ searchProps }: DropdownSearchHeaderProps) {
	return (
		<ListSubheader
			sx={{
				borderBottom: "1px solid #EAEAEA",
				lineHeight: 0,
				width: "100%",
				padding: "0.5rem",
			}}
			onKeyDown={(e) => {
				if (e.key !== "Escape") {
					e.stopPropagation();
				}
			}}
		>
			<CoreTextField
				size="small"
				autoFocus
				fullWidth
				placeholder={searchProps.placeholder ?? i18nPackage.t("coreComponents.selectSearch.placeholder")}
				value={searchProps.value}
				onChange={(e) => searchProps.onChange(e.target.value)}
				InputProps={{
					startAdornment: (
						<InputAdornment position="start">
							<SearchIcon />
						</InputAdornment>
					),
				}}
			/>
		</ListSubheader>
	);
}
